import http from "../index"
import {
  apiGetAllContracts,
  apiGetContractDetail,
  apiCreateContract,
  apiUpdateContract,
  apiDeleteContract,
  apiTerminateContract,
  apiUploadScanFile,
  apiGetAllPersonel,
  apiSignContract,
  apiSendContractOtp,
  apiGetSignatoryConfig,
  apiSaveSignatoryConfig
} from "./urls"

const getAllContracts = (params) => http.get(apiGetAllContracts, { params })
const getContractDetail = (id) => http.get(apiGetContractDetail(id))
const createContract = (payload) => http.post(apiCreateContract, payload)
const updateContract = (id, payload) => http.post(apiUpdateContract(id), payload)
const deleteContract = (id) => http.delete(apiDeleteContract(id))
const terminateContract = (id, payload) => http.post(apiTerminateContract(id), payload)
const uploadScanFile = (id, payload) => http.post(apiUploadScanFile(id), payload)
const getAllPersonel = (params = { detail: 1 }) => http.get(apiGetAllPersonel, { params: { detail: 1, ...params } })
const signContract = (id, payload) => http.post(apiSignContract(id), payload)
const sendContractOtp = (id) => http.post(apiSendContractOtp(id))
const getSignatoryConfig = () => http.get(apiGetSignatoryConfig)
const saveSignatoryConfig = (payload) => http.post(apiSaveSignatoryConfig, payload)

const ContractService = {
  getAllContracts,
  getContractDetail,
  createContract,
  updateContract,
  deleteContract,
  terminateContract,
  uploadScanFile,
  getAllPersonel,
  signContract,
  sendContractOtp,
  getSignatoryConfig,
  saveSignatoryConfig,
}

export default ContractService
